import {
  PivotTableGroup,
  PivotTableFields,
  FilterComparison,
  Widget,
  DashboardWidgetName,
  FilterLogic,
  PivotTableLayout,
  AnalyticsField,
} from '@types'
import { TagClass } from '@/entities/tags'

import { TAG_FIELD } from '@/const'
import { WIDGETS_LIST } from '@/views/Dashboards/Dashboard/Widgets/utils/const'
import { ACCOUNT_TYPES_LIST } from '../Dashboard/Widgets/AccountsByType/utils/const'
import { LINKED_TRANSACTION_FIELDS } from '@/views/LinkedData/Transactions/utils/const'
import { DEFAULT_COLS } from '@/views/Dashboards/Dashboard/Widgets/LinkedTransactions/utils/const'
import { DEFAULT_CONFIG_NAME } from '@/components/UI/PivotTable/utils/const'

import { stringToDateTime } from '@/helpers/dates'
import { generateId } from '@/entities/utils/helpers'
import { generateRandomKey } from '@/helpers'

export const prepareTagsList = (tagsBunch: Map<string, TagClass>, enabled = false) => {
  const result: PivotTableFields = {}
  const values = Array.from(tagsBunch.values())
  for (let i = 0; i < values.length; i++) {
    const tagName = values[i].field<string>(TAG_FIELD.TAG_NAME).value
    result[tagName] = {
      group: PivotTableGroup.ROWS,
      enabled,
    }
  }
  return result
}

export const getDatePoints = (dates: string[], date: string) => {
  const dateObject = stringToDateTime(date)
  const dateIndex = dates.findIndex(
    value => dateObject && stringToDateTime(value)?.hasSame(dateObject, 'day'),
  )
  let dateStart: string | undefined
  let dateEnd: string
  if (dates.length === 1) {
    dateStart = undefined
    dateEnd = dates[0]
  } else if (dateIndex === 0) {
    dateStart = undefined
    dateEnd = dates[0]
  } else {
    dateStart = dates[dateIndex - 1]
    dateEnd = date
  }
  return { dateStart, dateEnd }
}

export const getDefaultLinkedTransactionsAttrs = (): Widget['attrs'] => ({
  count: 15,
  filter: {
    params: [
      {
        key: generateRandomKey(),
        params: [
          {
            key: generateRandomKey(),
            comparison: FilterComparison.NOTCONTAINS,
            field: LINKED_TRANSACTION_FIELDS.TAGS.field,
            value: 'exclude',
          },
        ],
        logic: FilterLogic.AND,
      },
    ],
    logic: FilterLogic.AND,
  },
  cols: DEFAULT_COLS,
})

export const getDefaultValuePivotAttrs = (): Widget['attrs'] => {
  return {
    index: 0,
    configs: [
      {
        name: DEFAULT_CONFIG_NAME,
        open: true,
        layout: PivotTableLayout.MODERN,
        filter: {
          params: [
            {
              params: [
                {
                  key: generateRandomKey(),
                  comparison: FilterComparison.NOTEQ,
                  field: AnalyticsField.POSITION_CLOSE,
                  value: '0',
                }
              ],
              logic: FilterLogic.AND,
              key: generateRandomKey()
            }
          ],
          logic: FilterLogic.AND,
        },
        sortColumns: [],
        sortRows: [],
      },
    ],
  }
}

export const prepareNewWidgetParams = (name: DashboardWidgetName) => {
  let attrs: Widget['attrs'] = {}
  let wide = undefined
  let title =
    WIDGETS_LIST.find(item => item.name === name)?.label || 'New widget'
  switch (name) {
    case DashboardWidgetName.LinkedTransactions:
      title = 'Most recent linked transactions'
      attrs = getDefaultLinkedTransactionsAttrs()
      wide = true
      break
    case DashboardWidgetName.AccountsByType:
      attrs.type = ACCOUNT_TYPES_LIST[0]
      break
  }
  return {
    id: generateId(),
    name,
    title,
    attrs,
    wide,
  }
}
